import { v4 as uuidV4 } from 'uuid';
let dragImage;

export const createDragImage = elementId => {
  if (dragImage) {
    document.body.removeChild(dragImage);
  }

  dragImage = document.getElementById(elementId).cloneNode(true);
  dragImage.setAttribute('id', `drag-image-${uuidV4()}`);
  dragImage.style.position = 'absolute';
  dragImage.style.left = '-10000px';
  document.body.appendChild(dragImage);

  return dragImage;
};
